// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".context_button[data-v-33952366]{color:var(--cosmic-gray-lighten-3);height:var(--cosmic-top-nav-bar-height);&[data-v-33952366]:focus-visible,&[data-v-33952366]:hover{background:var(--cosmic-gray-lighten-3);color:var(--cosmic-text)}}", ""]);
// Exports
module.exports = exports;
